<div class="sidebar-container" #sidebarPanel>
  <div class="sidebar h-100">
    <ng-container *ngFor="let button of buttons">
      <a
        *ngIf="
          button.shouldDisplay == undefined || button.shouldDisplay == true
        "
        class="sidebar-btn"
        (click)="selectComponent(button)"
        [ngClass]="{ active: selectedComponent == button.componentName }"
        [suiTooltipPlacement]="!isRtl ? 'start' : 'end'"
        suiTooltip="{{ button.label }}"
      >
        <fa-icon [icon]="button.icon"></fa-icon>
        <app-counter-badge
          *ngIf="button.counter > 0"
          [count]="button.counter"
        ></app-counter-badge>
      </a>
    </ng-container>
  </div>
  <app-sidebar-panel
    [isOpen]="isOpen"
    [title]="selectedComponentTitle"
    [icon]="selectedComponentIcon"
  ></app-sidebar-panel>
</div>
